import React, {useCallback, useMemo} from "react";
import useStyles from "./styles";
import StyledTextField from "./StyledTextField";
import {ItemField} from "../../CrudModule";
import {FormApi} from "final-form";


export interface ICrudDetailAutoFields<DT> {
    form: FormApi<DT>,
    itemFields: ItemField<DT>[],
    loading?: boolean,
    submitting?: boolean,
    excludeFields?: string[],
    includeFields?: string[],
}

const CrudDetailAutoFields = <DT,>({ form, itemFields, submitting, loading, excludeFields, includeFields} : ICrudDetailAutoFields<DT> ) => {
    const classes = useStyles();

    const getField = useCallback((field: ItemField<DT>, submitting?: boolean) => (
        <StyledTextField
            key={`field-${field.name}`}
            name={field.name}
            label={field.title}
            type={field.formFieldDef?.type}
            loading={loading}
            submitting={submitting}
            multiline={field.formFieldDef?.multiline}
        />
    ), [loading]);

    const fields = useMemo(() => {
        if (!itemFields) return [];
        return itemFields.filter((field) => {
            if (excludeFields && excludeFields.includes(field.name)) return false;
            if (includeFields && !includeFields.includes(field.name)) return false;
            return true;
        });
    }, [itemFields, excludeFields, includeFields]);

    return (
        <>
            {fields && fields
                .filter((field) => !field.formFieldDef?.ignore)
                .map((field) => (
                    field.formFieldDef?.render ? field.formFieldDef?.render(field, classes, form, submitting || loading) : (
                        <>
                            {getField(field, submitting)}
                        </>
                    )

                ))}
        </>
    );
};
export default CrudDetailAutoFields;